import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Grid, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import SettingsIcon from "@mui/icons-material/Settings";
import LearningContainer from "../../container/learning.container";
import VSNButton from "../../shared/VSNButton";
import VSNLoader from "../../shared/VSNLoader";
import VSNProgressiveImage from "../../shared/VSNProgressiveImage";
import VSNSearchBox from "../../shared/VSNSearchBox";
import { VSNSwiper } from "../../shared/VSNSwiper";
import VSNTypography from "../../shared/VSNTypography";
import { CloseIcon, ListIcon, ListIconFill } from "../../shared/icon";
import { categories, getContentTypeDetails } from "./LearningConstant";
import { LearningStyle } from "./LearningStyle";
import LearningSwiperComponent from "./LearningSwiperComponent";
import SearchResults from "./SearchResults";
import VSNToolTip from "../../shared/VSNToolTip";

export default function Learning() {
  const {
    learningResult,
    LearningLoader,
    onSearchChange,
    searchRef,
    learningSearchContent,
    learningSearchLoader,
    learningCategoryData,
    activeTab,
    setActiveTab,
    showSearch,
    bookMarkData,
    bookmark,
    handleCloseSearch,
    isLearningAdmin,
  } = LearningContainer();
  const classes = LearningStyle();
  const navigate = useNavigate();

  if (LearningLoader) {
    return <VSNLoader variant="fullPage" />;
  }

  return (
    <>
      <Box className={classes.learningTopNav}>
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          py={1}
          px={{ sm: 3, xs: 2 }}
        >
          <Box
            className={`${classes.learningBtn} ${
              activeTab === "learning" ? "active" : ""
            }`}
            onClick={() => setActiveTab("learning")}
          >
            Learning
          </Box>
          <Stack direction="row" ml="auto">
            <IconButton
              onClick={() => setActiveTab("checklist")}
              className={activeTab === "checklist" ? "active" : ""}
            >
              {activeTab === "checklist" ? <ListIconFill /> : <ListIcon />}
            </IconButton>

            {/* <IconButton
              onClick={() => setActiveTab("bookmark")}
              className={activeTab === "bookmark" ? "active" : ""}
            >
              {activeTab === "bookmark" ? (
                <BookmarkIcon />
              ) : (
                <BookmarkBorderIcon />
              )}
            </IconButton> */}
            <IconButton
              onClick={() => setActiveTab("search")}
              className={activeTab === "search" ? "active" : ""}
            >
              <SearchIcon />
            </IconButton>
          </Stack>
          <Stack
            className={classes.navBtn}
            direction="row"
            alignItems="center"
            gap={{ md: 2, xs: 1 }}
            width={{ sm: "auto", xs: activeTab !== "search" ? "auto" : "100%" }}
          >
            {activeTab === "search" && (
              <Stack
                direction="row"
                alignItems="center"
                gap={{ md: 1 }}
                width={{ sm: "auto", xs: "100%" }}
                ml={{ sm: 2, xs: 0 }}
                mt={{ sm: 0, xs: 1 }}
              >
                <VSNSearchBox
                  onChange={onSearchChange}
                  name="keyword"
                  inputRef={searchRef}
                  disableClearable
                  fullWidth
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: 0,
                      "& .MuiInputBase-input": {
                        padding: "11px",
                        paddingLeft: "16px",
                      },
                    },
                  }}
                />

                <IconButton onClick={handleCloseSearch}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            )}

            {isLearningAdmin && (
              <VSNToolTip arrow title="Learning Admin Page">
                <IconButton onClick={() => navigate("/learning-admin")}>
                  <SettingsIcon style={{ color: "var(--primary)" }} />
                </IconButton>
              </VSNToolTip>
            )}
          </Stack>
        </Stack>
      </Box>

      {activeTab === "learning" && (
        <>
          {learningResult?.banners?.length ? (
            <Box className={classes.yourPersonalitySliderMain}>
              <VSNSwiper
                className={classes.personalityMain}
                pagination
                navigation
                spaceBetween={20}
                breakpoints={{
                  1400: {
                    slidesPerView: 1,
                  },
                }}
                loop
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                }}
              >
                {learningResult?.banners?.map((el, index) => {
                  const { icon, label } = getContentTypeDetails(
                    el?.course_content?.content_type?.toLowerCase(),
                    "#fff"
                  );

                  return (
                    <SwiperSlide key={el?.course_id || index}>
                      <Box
                        className={classes.heroSection}
                        onClick={() => {
                          if (el?.course_content?.is_course) {
                            navigate(
                              `/learning/content/${el.course_content?.content_type?.toLowerCase()}/${
                                el?.course_id
                              }`
                            );
                          } else {
                            navigate(
                              `/learning/content/${el.course_content?.content_type?.toLowerCase()}/${
                                el?.course_id
                              }/${el?.course_content?.lesson_id}`
                            );
                          }
                        }}
                        sx={{ cursor: "pointer" }}
                      >
                        {el?.course_content?.thumbnail ? (
                          <VSNProgressiveImage
                            src={el?.course_content?.thumbnail}
                            alt={
                              el?.course_content?.display_name ??
                              "Learning Content"
                            }
                            className={classes.heroImage}
                            style={{
                              objectFit: "cover",
                              minHeight: "832px",
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                              top: 0,
                              left: 0,
                            }}
                            loading="lazy"
                          />
                        ) : (
                          <Box
                            sx={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              position: "absolute",
                              top: 0,
                              left: 0,
                            }}
                          >
                            <VSNTypography variant="h6" color="text.secondary">
                              No Image Available
                            </VSNTypography>
                          </Box>
                        )}

                        <Grid container className={classes.heroSectionContent}>
                          <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
                            <Stack p={{ sm: 4 }} gap={3}>
                              {el?.course_content?.display_name && (
                                <VSNTypography
                                  variant="h1"
                                  className={classes.lgHeading}
                                >
                                  {el?.course_content?.display_name}
                                </VSNTypography>
                              )}

                              {el?.course_content?.summary && (
                                <VSNTypography
                                  className="desc"
                                  dangerouslySetInnerHTML={{
                                    __html: el?.course_content?.summary,
                                  }}
                                />
                              )}

                              <VSNButton
                                sx={{
                                  width: "fit-content",
                                  padding: "12px 32px",
                                }}
                                startIcon={icon}
                                // handleClick={() =>
                                //   navigate(
                                //     `/learning/content/${el?.course_content?.content_type?.toLowerCase()}/${
                                //       el?.course_id
                                //     }`
                                //   )
                                // }
                              >
                                {label}
                              </VSNButton>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Box>
                    </SwiperSlide>
                  );
                })}
              </VSNSwiper>
            </Box>
          ) : (
            <Box pb={22} />
          )}

          <Box mt={{ lg: -15, xs: -10 }} position="relative" zIndex={1}>
            {learningResult?.sections?.map((el, index) =>
              el?.courses?.length > 0 ? (
                <LearningSwiperComponent
                  key={index}
                  title={el?.title}
                  description={el?.description}
                  cardData={el?.courses}
                  onCardClick={(e) => {
                    if (e?.course_content?.is_course) {
                      navigate(
                        `/learning/content/${e.course_content?.content_type?.toLowerCase()}/${
                          e?.course_id
                        }`
                      );
                    } else {
                      navigate(
                        `/learning/content/${e.course_content?.content_type?.toLowerCase()}/${
                          e?.course_id
                        }/${e?.course_content?.lesson_id}`
                      );
                    }
                  }}
                  onBookmark={bookmark}
                  getContentTypeDetails={getContentTypeDetails}
                  bookmarkedIds={bookMarkData?.map((b) => b.course_content?.id)}
                  navigationClass={`swiper-${el?.id}`}
                  exploreAll={() =>
                    navigate(
                      `/learning/explore-all?from=learning&id=${
                        el?.id
                      }&name=${encodeURIComponent(el?.title)}`
                    )
                  }
                  classes={classes}
                />
              ) : null
            )}
          </Box>
        </>
      )}

      {/* {activeTab === "bookmark" && (
        <Box
          py={2}
          px={{ md: 12, sm: 8, xsm: 6, xs: 3 }}
          mt={{ sm: 8, xs: showSearch ? 14 : 8 }}
        >
          <VSNTypography
            variant="h4"
            fontSize={{ sm: 34, xs: 30 }}
            fontWeight="600"
            mb={2}
          >
            My Stuff
          </VSNTypography>
          <LearningSwiperComponent
            title="Understanding the Different Vasana Styles"
            description="Discover the unique qualities of each Vasana types in this video series, designed to help you better understand yourself, others, and chart your path to thriving together."
            cardData={bookMarkData}
            onCardClick={(el) =>
              navigate(
                `/learning/content/${el.type.toLowerCase()}/${el.course_id}`
              )
            }
            onBookmark={bookmark}
            getContentTypeDetails={getContentTypeDetails}
            bookmarkedIds={bookMarkData.map((b) => b.course_id)}
            navigationClass="swiper"
            exploreAll={() => navigate(`/learning/explore-all`)}
            classes={classes}
          />
        </Box>
      )} */}

      {activeTab === "checklist" && (
        <Box py={4} px={4} mt={{ sm: 8, xs: showSearch ? 14 : 8 }}>
          <Grid container justifyContent="center">
            <Grid item md={11}>
              <VSNTypography variant="h5" fontWeight="600" mb={2}>
                Categories
              </VSNTypography>
              <Grid container spacing={3}>
                {learningCategoryData?.map((data, ind) => {
                  const { icon } = categories[ind % categories?.length];
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lmd={4}
                      xl={3}
                      key={ind}
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate(
                          `/learning/explore-all?from=categorys&id=${
                            data?.id
                          }&name=${encodeURIComponent(data?.name)}`
                        )
                      }
                    >
                      <Stack
                        className={classes.categoriesBox}
                        direction="column"
                        justifyContent="space-between"
                      >
                        <VSNTypography variant="h5">{data?.name}</VSNTypography>
                        <Box sx={{ display: "flex" }} gap={1}>
                          <VSNTypography
                            component="span"
                            color="var(--primary)"
                          >
                            Explore
                          </VSNTypography>
                          <ArrowForwardIcon
                            style={{ color: "var(--primary)" }}
                          />
                        </Box>
                        <Box className={classes.categoriesIcon}>{icon}</Box>
                      </Stack>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}

      {activeTab === "search" && (
        <SearchResults
          searchTerm={searchRef}
          cardData={learningSearchContent}
          loader={learningSearchLoader}
          onCardClick={(e) =>
            navigate(`/learning/content/${e.type.toLowerCase()}/${e.course_id}`)
          }
          onBookmark={bookmark}
          getContentTypeDetails={getContentTypeDetails}
          bookmarkedIds={bookMarkData?.map((b) => b.course_id)}
          classes={classes}
          showSearch={showSearch}
        />
      )}
    </>
  );
}
